import api from '../services/api'

export interface BlogPostListItem {
  id: number
  slug: string
  title: string
  excerpt?: string
  cover_image?: string | null
  published_at?: string | null
}

export interface BlogBanner {
  title?: string | null
  description?: string | null
  button_text?: string | null
  button_url?: string | null
  image?: string | null
}

export interface BlogPostsResponse {
  data: BlogPostListItem[]
  featured?: BlogPostListItem | null
  pinned?: BlogPostListItem[]
  meta: {
    current_page: number
    last_page: number
    per_page: number
    total: number
  }
}

export const getBlogPosts = (page: number = 1): Promise<BlogPostsResponse> => {
  return api.get('/blog-posts', { params: { page } }).then((res) => res.data)
}

export const getBlogPost = (_: string, { slug }: { slug: string }) => {
  return api.get(`/blog-posts/${slug}`).then((res) => res.data.data)
}
